module.exports = __webpack_public_path__ + "static/globalone-0ef5700389fa29f6c6ff2865513b24dc.png";